// This file defines the main navigation configuration 
// The config is used in the common ui angular library as input for rendering the TaaS standard main navigation on the left side

import { TaasMenuItem } from "utimaco-common-ui-angular";
import helpIcon from '@material-icons/svg/svg/help/baseline.svg';
import shoppingCart from '@material-icons/svg/svg/shopping_cart/baseline.svg'

// see https://netbasal.com/simplifying-file-imports-in-angular-with-new-loader-options-4e94a0eb18af for importing svgs in angular ^17.1

export const TAAS_MENU_ITEM_LIST_TS: TaasMenuItem[] = [
    { id: 0, type: "link", active: false, name: $localize`:main-menu marketplace link:Marketplace`, link: "/", iconSvg: shoppingCart, children: [] },
    { id: 1, type: "link", active: false, name: $localize`:main-menu help link:Help`, link: "/help", iconSvg: helpIcon, children: [] },
];